import Axios from 'axios'
import config from '@/config/config.js'

// const baseUrl = 'http://192.168.242.74:8092/swagger-ui.html'
// const baseUrl = (config.isProd ? config.apiDomain.LC + '/b2/ali-personal-service/eLeave/api/' : config.apiDomain.ALI + '/ext/ps/eLeave/api/')
const baseUrl = config.apiDomain.ALI + '/ext/ps/eLeave/api/'
// const feriasStartWorkflowUrl = baseUrl + 'ferias/startWorkflow'
// const SIGN_LINK = 'getMacauPostSignLink'
const SIGN_LINK = 'getIdentificationLink'
const SIGN_START_WORKFLOW = 'identificationSignAndStartWorkflow'
const FERIAS = 'ferias/'
const FALTAS = 'faltas/'
const TRANSFER = 'feriasTransfer/'
const staffLeaveStatUrl = baseUrl + 'staffLeaveStat/' // /api/staffLeaveStat/{year} Get staff leave stat. 取得可登記年假日數
const feriasGetSignLinkUrl = baseUrl + FERIAS + SIGN_LINK // Get ferias identification sign link
const faltasGetSignLinkUrl = baseUrl + FALTAS + SIGN_LINK // Get faltas identification sign link.
const eLeaveAbsenceTypeUrl = baseUrl + FALTAS + 'eLeaveFormAbsentType'
const transferGetSignLinkUrl = baseUrl + TRANSFER + SIGN_LINK
const feriasSignAndStartWorkflowUrl = baseUrl + FERIAS + SIGN_START_WORKFLOW
const faltasSignAndStartWorkflowUrl = baseUrl + FALTAS + SIGN_START_WORKFLOW
const transferSignAndStartWorkflowUrl = baseUrl + TRANSFER + SIGN_START_WORKFLOW
// const searchStaffUrl = baseUrl + 'searchStaffs?limit=40&keyword='
const staffLeaveMarkUrl = baseUrl + 'staffLeaveMark/' //  /api/staffLeaveMark/{year}/available
const faltasNumDaysUrl = baseUrl + FALTAS + 'getNumDays/' // {startDate}/{endDate}/{absentTypeId}
const staffFeriasUrl = baseUrl + 'staffFerias/' // {year}
const staffFaltasUrl = baseUrl + 'staffFaltas/' // {year}
const staffCompensateHoursUrl = baseUrl + 'staffCompensateHours/' // {year}
const staffLeaveMarkStatusUrl = baseUrl + 'staffLeaveMarkStatus/' // {year} 取得人員當年年假登記狀態
const staffLeaveMarkWithFeriasRecordUrl = baseUrl + 'staffLeaveMarkWithFeriasRecord/' // {year} 用戶已登記之年假及已批准/申請中之年假資訊

const insertStaffLeaveMarkUrl = baseUrl + 'tempSave/insertStaffLeaveMark'
const updateStaffLeaveMarkUrl = baseUrl + 'tempSave/updateStaffLeaveMark'
const deleteStaffLeaveMarkUrl = baseUrl + 'tempSave/deleteStaffLeaveMark'
const leaveMarkGetIdLinkUrl = baseUrl + 'leaveMark/getIdentificationLink'
const leaveMarkIdSignAndStartWorkflowUrl = baseUrl + 'leaveMark/identificationSignAndStartWorkflow'
const getLeaveMarkFormUrl = baseUrl + 'getLeaveMarkForm?year='
const getDraftDiscreteLeaveMarkFormUrl = baseUrl + 'getDraftStaffDiscreteLeaveMarkForm'
const workingDaysUrl = baseUrl + 'getWorkingDays/' // {startDate}/{endDate}    可設定補假日是否計算為工作日
const hrEleaveEntityConfigUrl = baseUrl + 'hrEleaveEntityConfig'
const staffAbsentWorkingDaysUrl = baseUrl + 'getStaffAbsentWorkingDays/' // {startDate}/{endDate}/{absentTypeId}
const uploadFileUrl = baseUrl + 'uploadFile?businessCode='

// discrete (離散)
// 取得discrete (離散) mapa 連年假記錄
// /eLeave/api/staffDiscreteLeaveMarkWithFeriasRecord/{year}
const staffDiscreteLeaveMarkWithFeriasRecordUrl = baseUrl + 'staffDiscreteLeaveMarkWithFeriasRecord/'
// 新增discrete (離散) mapa (1筆)
// /eLeave/api/tempSave/insertStaffDiscreteLeaveMark
const insertStaffDiscreteLeaveMarkUrl = baseUrl + 'tempSave/insertStaffDiscreteLeaveMark'
// 更新discrete (離散) mapa (1筆)
// /eLeave/api/tempSave/updateStaffDiscreteLeaveMark
const updateStaffDiscreteLeaveMarkUrl = baseUrl + 'tempSave/updateStaffDiscreteLeaveMark'
// 刪除discrete (離散) mapa (1筆)
// /eLeave/api/tempSave/deleteStaffDiscreteLeaveMark
const deleteStaffDiscreteLeaveMarkUrl = baseUrl + 'tempSave/deleteStaffDiscreteLeaveMark'

// const insertFormUrl = '/api/ApplicationFormData/insertNewform'

// Axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
Axios.defaults.headers.timeout = 8000

export default {
  feriasGetSignLinkUrl,
  faltasGetSignLinkUrl,
  feriasSignAndStartWorkflowUrl,
  faltasSignAndStartWorkflowUrl,
  transferGetSignLinkUrl,
  transferSignAndStartWorkflowUrl,
  leaveMarkGetIdLinkUrl,
  leaveMarkIdSignAndStartWorkflowUrl,
  uploadFileUrl,

  // OK: return eSign link
  // not OK: return HTTP 400
  submitFeriasForm (form, cb) {
    Axios.post(feriasGetSignLinkUrl, form).then(
      response => {
        cb(response)
        // console.log(response.status)
      },
      error => {
        console.error(error)
        cb(error.response)
      }
    )
  },

  // OK: return eSign link
  // not OK: return HTTP 400
  submitFaltaForm (form, cb) {
    Axios.post(faltasGetSignLinkUrl, form).then(
      response => {
        cb(response)
        // console.log(response.status)
      },
      error => {
        console.error(error)
        cb(error.response)
      }
    )
  },

  // 本年獲得年假日數: daysGetThisYear
  // 累積日數: daysFromLastYear + daysCompansatThisYear
  // 扣除日數: daysAnteLastYear + daysInjustifiedLastYear + daysAjustThisYear + daysToNextYearOfficial + daysToNextYearPersonal
  // 尚餘年假日數: 本年獲得年假日數 + 累積日數 - 扣除日數 – 用戶在頁面已登記之年假日數
  // 獲得年假的日期: effectiveDate
  // 獲得特別假期的日期: nextRightDate

  getStaffLeaveStat (year, cb) {
    Axios.get(staffLeaveStatUrl + year).then(
      response => {
        cb(response.data)
      },
      error => {
        console.log(error)
      }
    )
  },

  getAvailableStaffLeaveMark (year, cb) {
    Axios.get(staffLeaveMarkUrl + year + '/available').then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  getFaltasAbsenceTypes (cb) {
    Axios.get(eLeaveAbsenceTypeUrl).then(
      response => {
        cb(response.data)
      },
      error => {
        console.log(error)
      }
    )
  },

  getFaltasNumDays (startDate, endDate, absentTypeId, cb) {
    Axios.get(faltasNumDaysUrl + startDate + '/' + endDate + '/' + absentTypeId).then(
      response => {
        cb(response.data)
      },
      error => {
        console.log(error)
      }
    )
  },

  getStaffFeriasByYear (payload, cb) {
    Axios.get(staffFeriasUrl + payload.startYear + '/' + payload.endYear).then(
      response => {
        cb(response.data)
      },
      error => {
        console.log(error)
      }
    )
  },

  getStaffFaltasByYear (payload, cb) {
    Axios.get(staffFaltasUrl + payload.startYear + '/' + payload.endYear).then(
      response => {
        cb(response.data)
      },
      error => {
        console.log(error)
      }
    )
  },

  getStaffCompensateHours (year, cb) {
    Axios.get(staffCompensateHoursUrl + year).then(
      response => {
        cb(response.data)
      },
      error => {
        console.log(error)
      }
    )
  },

  getStaffLeaveMarkStatusByYear (year, cb) {
    Axios.get(staffLeaveMarkStatusUrl + year).then(
      response => {
        cb(response.data)
        // 返回status:
        // E: 可編輯 <- 只允許此狀態用戶編輯年假登記
        // S: 已提交
        // A: 已批准
      },
      error => {
        console.log(error)
      }
    )
  },

  getStaffLeaveMarkWithFeriasRecordByYear (year, cb) {
    Axios.get(staffLeaveMarkWithFeriasRecordUrl + year).then(
      response => {
        cb(response.data)
      },
      error => {
        console.log(error)
      }
    )
  },

  // data: {
  //   "endDate": "2020-11-23T03:55:30.414Z",
  //   "markTypeId": 0,
  //   "startDate": "2020-11-23T03:55:30.414Z"
  // }
  insertStaffLeaveMark (data, cb) {
    Axios.post(insertStaffLeaveMarkUrl, data).then(
      response => {
        cb(response)
        // console.log(response.status)
      },
      error => {
        console.error(error)
        cb(error.response)
      }
    )
  },

  // data {
  //   "endDate": "2020-11-23T04:18:57.429Z",
  //   "markTypeId": 0,
  //   "oldStartDate": "2020-11-23T04:18:57.429Z",
  //   "startDate": "2020-11-23T04:18:57.429Z"
  // }
  updateStaffLeaveMark (data, cb) {
    Axios.post(updateStaffLeaveMarkUrl, data).then(
      response => {
        cb(response)
        // console.log(response.status)
      },
      error => {
        console.error(error)
        cb(error.response)
      }
    )
  },

  deleteStaffLeaveMark (startData, cb) {
    Axios.post(deleteStaffLeaveMarkUrl, startData).then(
      response => {
        cb(response)
        // console.log(response.status)
      },
      error => {
        console.error(error)
        cb(error.response)
      }
    )
  },

  getLeaveMarkForm (year, cb) {
    let param = getLeaveMarkFormUrl + year
    Axios.get(param, {
      responseType: 'blob'
    }).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  getDraftDiscreteLeaveMarkForm (data, cb) {
    Axios.post(getDraftDiscreteLeaveMarkFormUrl, data, { responseType: 'blob' }).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  getStaffDiscreteLeaveMarkWithFeriasRecord (year, cb) {
    Axios.get(staffDiscreteLeaveMarkWithFeriasRecordUrl + year).then(
      response => {
        cb(response.data)
      },
      error => {
        console.log(error)
      }
    )
  },

  // {
  //   "absentTypeId": 0,
  //   "endDate": "",
  //   "id": 0,
  //   "oldStartDate": "",
  //   "startDate": ""
  // }
  updateStaffDiscreteLeaveMark (data, cb) {
    Axios.post(updateStaffDiscreteLeaveMarkUrl, data).then(
      response => {
        cb(response)
      },
      error => {
        console.error(error)
        cb(error.response)
      }
    )
  },

  // {
  //   "absentTypeId": 0,
  //   "endDate": "",
  //   "startDate": ""
  // }
  insertStaffDiscreteLeaveMark (data, cb) {
    Axios.post(insertStaffDiscreteLeaveMarkUrl, data).then(
      response => {
        cb(response)
      },
      error => {
        console.error(error)
        cb(error.response)
      }
    )
  },

  deleteStaffDiscreteLeaveMark (startDate, cb) {
    Axios.post(deleteStaffDiscreteLeaveMarkUrl, startDate).then(
      response => {
        cb(response)
      },
      error => {
        console.error(error)
        cb(error.response)
      }
    )
  },

  getStaffLeaveMark (year, cb) {
    return new Promise((resolve, reject) => {
      Axios.get(staffLeaveMarkUrl + year).then(
        response => {
          cb(response.data)
          resolve()
        },
        error => {
          console.error(error)
        }
      )
    })
  },

  getWorkingDays (startDate, endDate, cb) {
    return new Promise((resolve, reject) => {
      Axios.get(workingDaysUrl + startDate + '/' + endDate).then(
        response => {
          cb(response.data)
          resolve()
        },
        error => {
          console.error(error)
          reject.error(error.response)
        }
      )
    })
  },

  getHrEleaveEntityConfig (cb) {
    return new Promise((resolve, reject) => {
      Axios.get(hrEleaveEntityConfigUrl).then(
        response => {
          cb(response.data)
          resolve()
        },
        error => {
          console.error(error)
          reject.error(error.response)
        }
      )
    })
  },

  getStaffAbsentWorkingDays (startDate, endDate, absentTypeId, cb) {
    return new Promise((resolve, reject) => {
      Axios.get(staffAbsentWorkingDaysUrl + startDate + '/' + endDate + '/' + absentTypeId).then(
        response => {
          cb(response.data)
          resolve()
        },
        error => {
          console.error(error)
          reject.error(error.response)
        }
      )
    })
  }

}
